// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Controller Rollout API
 * Fleet-wide view and control of Rollout CRDs across orchestras
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface ResponseResourceReference
 */
export interface ResponseResourceReference {
  /**
   *
   * @type {string}
   * @memberof ResponseResourceReference
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof ResponseResourceReference
   */
  namespace?: string;
}

/**
 * Check if a given object implements the ResponseResourceReference interface.
 */
export function instanceOfResponseResourceReference(
  value: object,
): value is ResponseResourceReference {
  return true;
}

export function ResponseResourceReferenceFromJSON(
  json: any,
): ResponseResourceReference {
  return ResponseResourceReferenceFromJSONTyped(json, false);
}

export function ResponseResourceReferenceFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ResponseResourceReference {
  if (json == null) {
    return json;
  }
  return {
    name: json['name'] == null ? undefined : json['name'],
    namespace: json['namespace'] == null ? undefined : json['namespace'],
  };
}

export function ResponseResourceReferenceToJSON(
  json: any,
): ResponseResourceReference {
  return ResponseResourceReferenceToJSONTyped(json, false);
}

export function ResponseResourceReferenceToJSONTyped(
  value?: ResponseResourceReference | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    name: value['name'],
    namespace: value['namespace'],
  };
}
